<svg xmlns="http://www.w3.org/2000/svg" version="1.1" [attr.width]="width" [attr.height]="height" [attr.viewbox]="viewbox"
  xml:space="preserve" preserveAspectRatio="xMidYMid meet">

  <g>
    <rect id="positiveBar" [attr.x]="positiveBarX" [attr.y]="barY" [attr.width]="positiveBarWidth" [attr.height]="barHeight" [attr.fill]="positiveColor" [ngClass]="{'is-positive': isPositive}" />
    <rect id="negativeBar"  [attr.x]="negativeBarX" [attr.y]="barY" [attr.width]="negativeBarWidth" [attr.height]="barHeight" [attr.fill]="negativeColor" [ngClass]="{'is-positive': isPositive}" />
    <line [attr.x1]="halfWidth" y1="0" [attr.x2]="halfWidth" [attr.y2]="height" stroke="#dbdbdb" stroke-width="1" />
  </g>
</svg>